import axiosInstance from '../../axiosInstance';
import { selectUser } from '../Auth/selector';
import { setProfile } from './slice';

export const fetchProfile = () => async (dispatch, getState) => {
  const user = selectUser(getState());
  if (!user) return;
  try {
    const response = await axiosInstance.get(`user/fetch/${user._id}`);
    dispatch(setProfile(response.data.result));
  } catch (err) {
    console.log(err);
  }
};

export const updateProfile = (formData) => async (dispatch, getState) => {
  const user = selectUser(getState());
  if (!user) return;
  try {
    const { firstName, lastName, address } = formData;
    const data = {
      email: user.email,
      firstName,
      lastName,
      address,
    };
    const token = localStorage.getItem('token');
    const headers = { Authorization: token };
    const response = await axiosInstance.put('user', data, { headers });
    alert('Success');
    dispatch(setProfile(response.data.result));
  } catch (err) {
    if (err.response?.data) {
      const { error: errorMsg } = err.response.data;
      alert(errorMsg);
    } else {
      alert(err);
    }
  }
};
